import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, DatePicker, Select } from 'components';
import { Field, Form, Formik } from 'formik';
import { downloadXlsx } from 'helpers/downloadXlsx';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providersService } from 'services';

import { formatDate } from '../../../../helpers/formateDate';

export const NonComplianceReport = () => {
  const operations = [
    { label: 'TODOS', value: 0 },
    { label: 'E-COMMERCE', value: 7 },
    { label: 'NÃO SERIALIZADO', value: 20 },
    { label: 'RFB CENTER CELL', value: 10 },
    { label: 'RFB FURBTECH SOR', value: 21 },
    { label: 'RFB SAMSUNG', value: 9 },
    { label: 'RFB TECH CENTER', value: 19 },
  ];

  const typeProcess = [
    { label: 'Triagem', value: 0 },
    { label: 'QA', value: 1 },
    { label: 'SW', value: 2 },
  ];

  const [loading, setIsLoading] = useState(false);
  const now = new Date();

  const handleExport = async (values) => {
    setIsLoading(true);
    toast.info('Aguarde relatório sendo gerado...');
    try {
      const { data } = await providersService.nonComplianceReport({ values });
      const result = data.result;
      const date = await formatDate(now);

      if (data.status === 200) {
        toast.success(data.msg);
        await downloadXlsx(`Relatório_Nao_Conformidade${date}`, result);
        setIsLoading(false);
      } else {
        toast.error(data.msg);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error.message);
      setIsLoading(false);
    }
  };
  return (
    <>
      <PageTitle>Não Conformidade</PageTitle>

      <Formik
        initialValues={{
          operation: 0,
          input_data: new Date(),
          output_data: new Date(),
          type_process: 0,
        }}
        onSubmit={handleExport}
      >
        {(props) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={2}>
                <Field
                  size='small'
                  variant='outlined'
                  component={Select}
                  name='operation'
                  label='Operação'
                  options={operations}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2}>
                <Field
                  size='small'
                  name='input_data'
                  variant='inline'
                  fullWidth
                  inputVariant='outlined'
                  label='Data Inicio'
                  component={DatePicker}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2}>
                <Field
                  size='small'
                  name='output_data'
                  variant='inline'
                  fullWidth
                  inputVariant='outlined'
                  label='Data Final'
                  component={DatePicker}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2}>
                <Field
                  size='small'
                  variant='outlined'
                  component={Select}
                  name='type_process'
                  label='Processo'
                  options={typeProcess}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2}>
                <Button type='submit' fullWidth loading={loading}>
                  Exportar Relatório
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};
